// extracted by mini-css-extract-plugin
export default {"order-feedback-card":"CardPaymentRedirect_order-feedback-card__nRO49","payment-specific-feedback":"CardPaymentRedirect_payment-specific-feedback__2n8z8"};